import OBRAS from '@/graphql/querys/administracion/planeacion/obras.gql';
import AGREGAR_PRESUPUESTO_DETALLES from '@/graphql/mutations/administracion/presupuestos/agregarPresupuestoDetalles.gql';
import REMOVER_PRESUPUESTO_DETALLE from '@/graphql/mutations/administracion/presupuestos/removerPresupuestoDetalle.gql';
import PRESUPUESTOS from '@/graphql/querys/administracion/presupuestos/presupuestos.gql';

export default {
  apollo: {
    obras: {
      query: OBRAS,
    },
    presupuestos: {
      query: PRESUPUESTOS,
    },
  },
  data() {
    return {
      enviandoFormulario: false,
      nuevosDetalles: [],
    };
  },
  mounted() {},
  methods: {
    async mixAgregarPresupuestoDetalles() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_PRESUPUESTO_DETALLES,
        variables: {
          id: this.presupuestoId,
          presupuestoDetalles: this.nuevosDetalles,
        },
        update: (store, { data: { agregarPresupuestoDetalles } }) => {
          const data = store.readQuery({ query: PRESUPUESTOS });
          const { presupuestos } = data;
          const index = presupuestos.findIndex(({ id }) => id === this.presupuestoId);
          if (index !== -1) {
            presupuestos.splice(index, 1, agregarPresupuestoDetalles);
          }

          store.writeQuery({ query: PRESUPUESTOS, data });
        },
      })
        .then(() => this.mixMensajeSuccess())
        .catch((err) => this.mixMensajeError(err));

      this.enviandoFormulario = false;
      this.nuevosDetalles = [];
      this.mixEsCargando();
      this.$emit('cerrar');
    },
    async mixEliminarPresupuestoDetalle() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_PRESUPUESTO_DETALLE,
        variables: { id: this.presupuestoDetalleId },
        update: (store) => {
          const data = store.readQuery({ query: PRESUPUESTOS });
          const { presupuestos } = data;

          const presupuesto = presupuestos.find(({ id }) => id === this.presupuestoId);
          if (!presupuesto) return;

          const index = presupuesto.detalles
            .findIndex(({ id }) => id === this.presupuestoDetalleId);
          if (index === -1) return;

          presupuesto.detalles.splice(index, 1);
          store.writeQuery({ query: PRESUPUESTOS, data });
        },
      })
        .then(() => this.mixMensajeSuccess())
        .catch((err) => this.mixMensajeError(err));

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.verEliminarDetalle = false;
      // this.cerrar();
    },
  },
  computed: {
    getDetallesPresupuesto() {
      if (!this.getPresupuesto || !this.getPresupuesto.detalles) return [];
      return this.getPresupuesto.detalles;
    },
    getPresupuesto() {
      if (!this.presupuestos) return {};
      return this.presupuestos.find(({ id }) => id === this.presupuestoId);
    },
  },
};
